import { DomainLibsFn } from "../libs/host";
import * as WinForm from '../winform';
export class OpenService {
    static previewImg(images, curImg) {
        let _index = 0, realW = 0, realH = 0;
        let imgSrcArr = [].map.call(images, (img, index) => {
            if (img === curImg) {
                _index = index;
                realW = img.naturalWidth;
                realH = img.naturalHeight;
            }
            let realSrc = img.getAttribute("props");
            return img.src.replace(/\?x-oss-process=[^=]+$/, "");
        });
        this.openImgPreview(_index, imgSrcArr);
    }
    static openImgPreview(imgIndex, imgArr = []) {
        imgArr = imgArr.map((item) => {
            if (item.indexOf(';base64,') == -1) {
                return item.indexOf('http') != 0 ? 'http:' + item : item;
            }
            else {
                return item;
            }
        });
        WinForm.md.$emit('preview_img', JSON.stringify({
            imgArr,
            imgIndex,
        }));
        WinForm.md.showWindow(`${DomainLibsFn().ImWeb}/local_lib/imgviewer.html`);
    }
    /**
     * 打开企业首页
     * @param CompID
     */
    static openCompDetail(CompID) {
        let origin = this.getEngineerWebOrigin();
        window.open(`${origin}/company/home/${CompID}`);
    }
    /**
     * 获取企业首页地址
     * @param CompID
     * @returns
     */
    static getCompDetailUrl(CompID) {
        let origin = this.getEngineerWebOrigin();
        return `${origin}/company/home/${CompID}`;
    }
    /**
     * 打开产品详情页
     * @param ProdID
     * @param lecto_params
     */
    static openProdDetails(ProdID, lecto_params = '') {
        let origin = this.getEngineerWebOrigin();
        let url = `${origin}/product/detail/${ProdID}`;
        let urlParams = {};
        lecto_params && (urlParams.lecto_params = lecto_params);
        Object.keys(urlParams).forEach((item, index) => {
            url = url + (index === 0 ? '?' : '&') + item + '=' + urlParams[item];
        });
        window.open(url);
    }
    /**
     * 获取产品详情页地址
     * @param ProdID
     * @returns
     */
    static getProdDetailUrl(ProdID, lecto_params = '') {
        let origin = this.getEngineerWebOrigin();
        let url = `${origin}/product/detail/${ProdID}`;
        let urlParams = {};
        lecto_params && (urlParams.lecto_params = lecto_params);
        Object.keys(urlParams).forEach((item, index) => {
            url = url + (index === 0 ? '?' : '&') + item + '=' + urlParams[item];
        });
        return url;
    }
    static getEngineerWebOrigin() {
        let origin = DomainLibsFn().EngineerWeb;
        if (['https://product-center.china2node.com'].includes(location.origin)) {
            origin = location.origin;
        }
        return origin;
    }
}
